import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hourglass, ArrowRight, X } from 'lucide-react';
import api from '../services/api';
import '../styles/Ritardi.css';
import PilaAvvisi from './PilaAvvisi';

/**
 * AttesaNotifier — chi sta aspettando TE, e da quanto.
 *
 * PERCHE' NON E' L'AVVISO DEI RITARDI GIRATO
 * Quello dice alla reception «questo paziente non e' arrivato». Questo
 * dice al medico una cosa che lui non puo' sapere: che il paziente e'
 * seduto in sala da venti minuti mentre lui e' ancora sul precedente.
 *
 * E NON DICE «IL PAZIENTE E' ARRIVATO», che sarebbe un'interruzione a
 * vuoto: il prossimo lo chiama quando ha finito comunque, e il pallino
 * giallo in agenda glielo direbbe gia' — se stesse guardando l'agenda,
 * che mentre visita non guarda. Quello che non sa e' da quanto aspetta,
 * ed e' l'unica cosa che qui compare in grande.
 *
 * L'ATTESA SI CONTA DAL PIU' TARDI FRA ARRIVO E ORARIO: chi si presenta
 * con mezz'ora di anticipo aspetta il proprio turno, non il medico. Un
 * avviso che accusa a torto viene spento la seconda volta.
 */

const OGNI = 60 * 1000;
const RINVIO = 10 * 60 * 1000;

const nomeDi = (r) => (r.paz_cognome ? `${r.paz_cognome} ${r.paz_nome}` : r.paziente_nome) || 'Paziente';

const AttesaNotifier = () => {
    const [attese, setAttese] = useState([]);
    const [rinviatiFino, setRinviatiFino] = useState({});
    const navigate = useNavigate();

    const controlla = useCallback(async () => {
        try {
            const r = await api.get('/agenda/in-attesa');
            setAttese(r.data?.data?.attese || []);
        } catch (e) { /* silenzio: non si pianta un riquadro per un errore di rete */ }
    }, []);

    useEffect(() => {
        controlla();
        const t = setInterval(controlla, OGNI);
        return () => clearInterval(t);
    }, [controlla]);

    const daMostrare = attese.filter((r) => (rinviatiFino[r.id] || 0) < Date.now());
    if (!daMostrare.length) return null;

    return (
        <PilaAvvisi riassunto={(n) => `${n} pazienti in attesa`} voci={daMostrare.map((r) => (
                <div className="rit-avviso rit-attesa" key={r.id}>
                    <button className="rit-rinvia"
                            onClick={() => setRinviatiFino((p) => ({ ...p, [r.id]: Date.now() + RINVIO }))}
                            title="Nascondi per dieci minuti">
                        <X size={14} aria-hidden="true" />
                    </button>

                    <div className="rit-testa rit-testa-attesa">
                        <Hourglass size={15} aria-hidden="true" />
                        <span className="rit-minuti">in sala d’attesa da {r.minuti_attesa} minuti</span>
                    </div>

                    <div className="rit-nome">{nomeDi(r)}</div>

                    <div className="rit-dettagli">
                        {r.stanza_nome && <span>{r.stanza_nome}</span>}
                        {r.id_paziente && <span>{r.id_paziente}</span>}
                    </div>
                    {r.prestazioni && <div className="rit-prestazioni">{r.prestazioni}</div>}

                    {r.paziente_id && (
                        <div className="rit-azioni">
                            {/* Si apre direttamente sulle procedure: e' il posto
                                dove si lavora, e la home della scheda
                                obbligherebbe a un clic in piu' con un paziente
                                che sta gia' aspettando. */}
                            <button className="rit-presente"
                                    onClick={() => navigate(`/pazienti/${r.paziente_id}`,
                                                            { state: { schermata: 'procedure' } })}>
                                <ArrowRight size={15} aria-hidden="true" /> Apri la cartella
                            </button>
                        </div>
                    )}
                </div>
            ))} />
    );
};

export default AttesaNotifier;
